import React, { Fragment, useEffect, useState } from "react";
import { Button, Row, Col } from "reactstrap";
import Tabs from "react-responsive-tabs";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

const ShowIntegrationInfo = ({ keyname, headData, integrationData, isInstalled, isConnected, accountInfo, onInstall, onRemove }) => {
    const [tabInfo, setTabInfo] = useState([]);
    const [integrationID, setintegrationID] = useState([]);
    // Set tabs when component mounts
    useEffect(() => {
        setTabView();
        if (Array.isArray(accountInfo) && accountInfo.length > 0 && accountInfo[0].id) {
            setintegrationID(accountInfo[0]);
        } else {
            setintegrationID([]); // Fallback if accountInfo is not an array or is empty
        }
    }, [accountInfo]);

    const onClickRemove = () => {
        let id = integrationID.id;    
        if(id == null){
            id = accountInfo[0].id;
        }
        onRemove(keyname,id);
    };

    const getAccountView = () => {
        return (
            !accountInfo == '' && accountInfo.length !== 0 && 
            <div className="ghl-account-details mt-3">
                <table>
                    <tbody>
                    {
                        accountInfo.filter(field => field.type !== "id").map((field, index) => (
                            <tr key={index}>
                                <td className="field-title p-2">{field.label}&nbsp;</td>
                                <td className="field-value p-2">{field.type === "password" ? "**** **** **** ****" : field.value}</td>
                            </tr>
                        ))
                    }
                    </tbody>
                </table>
                <div className="hor-8px mt-3 ms-2">
                    <button  onClick={() => onClickRemove()} className="btn btn-danger">Remove</button>
                </div>
            </div>
        );
    };

    // Function to initialize tab data
    const setTabView = () => {
        let tabs = [
            {
                name: "Accounts",
                biography: <Fragment>{getAccountView()}</Fragment>,
            },
            {
                name: "Info",
                biography: <Fragment>{getGeneralInfoView()}</Fragment>,
            },
        ];
        // setintegrationID();
        setTabInfo(tabs);
    };

    // Function to format tab items
    const getSimpleTabs = () => {
        return tabInfo.map(({ name, biography }, index) => ({
            key: index,
            title: name,
            getContent: () => biography, // Render function for content
        }));
    };

    // Function to display the integration header
    const getIntegrationHeader = () => (
        <div className="ghl-heading">
            <div className="ghl-details">
                <Row>
                    <Col md={1}>
                        <span className="card-image-status">
                            <img src={headData.image} className="intagration-card-detail-img" alt="Integration Logo" />
                        </span>
                    </Col>
                    <Col md={4} className="p-1">
                        <span className="heading">{headData.name}</span>
                        <span className="tag">{headData.tag}</span>
                    </Col>
                    <Col className="d-flex justify-content-end">
                        {!isInstalled ? (
                            <Button name="install" className="theme-bg-g btn-hover-shine m-2 p-2" onClick={() => onInstall(keyname,true)}>
                                <FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;
                                <span>{headData.installButtonText}</span>
                            </Button>
                        ) : (
                            <>
                            {keyname === 'email' &&
                                <Button name="install" className="btn theme-bg-g me-3 mb-3" onClick={() => onInstall('test_connect',true)}>
                                    <FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;
                                    <span>{headData.testConnectionText}</span>
                                </Button>
                            }
                            <Button name="uninstall" className="btn btn-danger p-2 me-0 mb-3"  onClick={() => onClickRemove()}>
                                <FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;
                                <span>{headData.uninstallButtonText}</span>
                            </Button>
                            </>
                        )}
                    </Col>
                </Row>
            </div>
        </div>
    );

    // Function to display account details


    // Function to display general information
    const getGeneralInfoView = () => (
        <div>
            {integrationData.map((item, index) => ( 
                <div key={index} className="card-fields mt-3">
                    <span className="field-name"><b>{item.heading}</b></span>
                    {item.type === "url" ? (
                        <span>
                            <a href={item.subheading} target="_blank" rel="noopener noreferrer">
                                {item.subheading}
                            </a>
                        </span>
                    ) : item.type === "text" ? (
                        <span className="subheading">{item.subheading}</span>
                    ) : item.type === "list" ? (
                            <div className="subheading ver-2px">
                                {
                                    item.subheading.map((benefit, idx) => (
                                        <div key={idx}>
                                            {benefit.title && <li className="subheading sender-list" >&#8226; {" " + benefit.title}</li>}
                                            {
                                                !!benefit.description && (
                                                    <ul className={"m-0 mb-1"}>
                                                        <li>{benefit.description}</li>
                                                    </ul>
                                                )
                                            }
                                        </div>
                                    ))
                                }
                            </div>
                    )  : null}
                </div>
            ))}
        </div>
    );

    // Function to display the agent details tab (if connected)
    const getAgentDetailsTab = () => {
        if (!isConnected) return null;
        return (
            <div className="agent-details-tab calls-details">
                <Row md={12}>
                    <Tabs
                        tabsWrapperClass="body-tabs"
                        activeTab={"1"}
                        showMore={true}
                        transform={true}
                        showInkBar={true}
                        selectedTabKey={0}
                        transformWidth={400}
                        items={getSimpleTabs()}
                    />
                </Row>
            </div>
        );
    };

    return (
        <Fragment>
            {getIntegrationHeader()}
            {isConnected && getAgentDetailsTab()}
            {!isConnected && getGeneralInfoView()}
            
        </Fragment>
    );
};

export default ShowIntegrationInfo;
